import Seo from "@/components/Seo";
import Header from "@/components/Header";
import HeroSection from "@/components/HeroSection";
import TrustStrip from "@/components/TrustStrip";
import ServicesSection from "@/components/ServicesSection";
import PackagesSection from "@/components/PackagesSection";
import HowItWorks from "@/components/HowItWorks";
import ReviewsSection from "@/components/ReviewsSection";
import QuoteForm from "@/components/QuoteForm";
import Footer from "@/components/Footer";
import StickyCallButton from "@/components/StickyCallButton";
import MovingSimpleSection from "@/components/MovingSimpleSection";
import ComparisonSection from "@/components/ComparisonSection";
import SocialProofStats from "@/components/SocialProofStats";
import FinalCta from "@/components/FinalCta";

const Index = () => (
  <>
    <Seo
      title="Oz Property Services Co. – Property Maintenance Melbourne"
      description="Melbourne property maintenance, repairs, upgrades and renovation support for homes, rentals and businesses. Fast photo-based quotes."
      path="/"
    />
    <Header />
    <main>
      <HeroSection />
      <TrustStrip />
      <HowItWorks />
      <QuoteForm />
      <ServicesSection />
      <PackagesSection />
      <MovingSimpleSection />
      <ReviewsSection />
      <ComparisonSection />
      <SocialProofStats />
      <FinalCta />
      <Footer />
      <StickyCallButton />
    </main>
  </>
);

export default Index;
